import ApiService from "utils/services/ApiService";
import { getTestResults } from "utils/services/idbService";

const convertSiteDataToDataPoints = async (siteId: number, row: any) => {
    let cachedData = await getTestResults(
        `allSites`,
        localStorage.getItem('currentUser') ?? 'unknown'
    );
    let cachedKits = await getTestResults(
        `defaultTestKits`,
        localStorage.getItem('currentUser') ?? 'unknown'
    );

    const siteIndex = cachedData.findIndex((site: SiteData) => site.id === siteId);
    if (siteIndex === -1) return null; // Site not found

    const sampleLocations = [...cachedData[siteIndex].sampleLocationAllVOs || []];
    const sampleLocationIndex = sampleLocations.findIndex((sampleL: any) => sampleL.id === row.samplePointId);
    if (sampleLocationIndex === -1) return null; // Sample location not found

    const dataPoints = [...cachedData[siteIndex].sampleLocationAllVOs[sampleLocationIndex].dataPointAllVOs || []];
    const dataPointIndex = dataPoints.findIndex((point: any) => point.id === row.id);
    if (dataPointIndex === -1) return null; // Data point not found

    // Get the selected data point
    const selectedDataPoint = dataPoints[dataPointIndex];

    let activeKit = cachedKits.find((kit: {id: number}) => selectedDataPoint.testKitId === kit.id);

    //remove hidden values from transformation
    let nonHiddenValueVOs: any[] = []
    selectedDataPoint.valueVOs.forEach((value: any) => {
        if (!isHidden(activeKit, value.outputId)) {
            nonHiddenValueVOs.push(value);
        }
    })
    selectedDataPoint.valueVOs = nonHiddenValueVOs;

    const sharedUsers = cachedData[siteIndex].sharedUserVOs || [];
    const operatorName = (selectedDataPoint?.operator ?? "").toString().trim();
    const currentUserEmail = (localStorage.getItem("currentUser") ?? "")
        .toString()
        .trim();
    const normalizedOperator = operatorName.toLowerCase();
    const normalizedCurrentEmail = currentUserEmail.toLowerCase();
    const matchedByOperator = sharedUsers.find((user: any) => {
        const name = (user?.name ?? "").toString().trim().toLowerCase();
        const email = (user?.email ?? "").toString().trim().toLowerCase();
        return (
            normalizedOperator &&
            (normalizedOperator === name || normalizedOperator === email)
        );
    });
    const matchedByEmail = sharedUsers.find((user: any) => {
        const email = (user?.email ?? "").toString().trim().toLowerCase();
        return normalizedCurrentEmail && normalizedCurrentEmail === email;
    });
    const ownerUser = sharedUsers.find((user: any) => user?.owner);
    const addedBy =
        (selectedDataPoint as any)?.addedBy ??
        matchedByOperator?.id ??
        matchedByEmail?.id ??
        ownerUser?.id ??
        null;

    // Transform data to the required structure
    const transformedData = {
        id: selectedDataPoint.id,
        timeStamp: selectedDataPoint.timestamp,
        samplePointName: sampleLocations[sampleLocationIndex].name,
        samplePointId: sampleLocations[sampleLocationIndex].id,
        status: "Active",
        addedBy,
        username:  selectedDataPoint.operator,
        note: selectedDataPoint.note,
        modificationDate: null, // Assuming there's no direct modification date
        isImported: false, // Assuming data is not imported
        testKitMeasurementResultVOs: [{
            testKitId: selectedDataPoint.testKitId,
            samplePointId: sampleLocations[sampleLocationIndex].id,
            resultId: selectedDataPoint.resultId,
            timeStamp: selectedDataPoint.timestamp,
            status: "Active",
            testKitMeasurementResultValueVOs: selectedDataPoint.valueVOs.map((value: any) => ({
                name: value.outputId,
                value: value.outputValue,
                id: value.id,
                type: determineInputOutput(activeKit, value.outputId),
                alarmType: value.outputAlarm,
                displayName: value.displayName,
                status: "Active",
            }))
        }],
        supplementalDataValueVOs: [] // Assuming you may want to populate this later
    };

    return transformedData;
}
export default convertSiteDataToDataPoints

function determineInputOutput (testKit: any, outputId: string): string {

    let descriptors = testKit.fieldDescriptorAllVOs;
    
    let descriptor = descriptors.find((desc: {outputId: string}) => desc.outputId === outputId);
    let type = descriptor?.type === "Output" ? "Output" : "Input";

    return type;

}

function isHidden (testKit: any, outputId: string): boolean {

    let descriptors = testKit.fieldDescriptorAllVOs;
    let descriptor = descriptors.find((desc: {outputId: string}) => desc.outputId === outputId);

    return descriptor?.hidden ?? false;

}